module.exports = __webpack_public_path__ + "img/icon-eye-gray.3f3037f6.svg";